import React from "react";

import Label from "@busbud/design-system-components/dist/Label";

import { useAppContext } from "@app/helpers/hooks";
import { removeTimeOffset } from "@app/helpers/time";

import { useStyles } from "./checkpoint-time.styles";

interface Props {
  day_difference?: number | null;
  value: string;
  variant?: "major" | "minor";
}

export const CheckpointTime: React.FC<Props> = ({
  day_difference = 0,
  value,
  variant = "major"
}) => {
  const { intlProvider } = useAppContext();
  const { cx, classes } = useStyles();

  const datetime_without_timezone_offset = removeTimeOffset(value);

  const formatted_date = intlProvider.formatDate(
    datetime_without_timezone_offset,
    {
      month: "long",
      day: "numeric",
      weekday: "short"
    }
  );
  const formatted_time = intlProvider.formatTime(
    datetime_without_timezone_offset
  );

  return (
    <div
      className={cx(classes.container, {
        [classes.major]: variant === "major"
      })}
    >
      <Label
        className={classes.label}
        component="time"
        dateTime={datetime_without_timezone_offset}
        fontWeight="bold"
        size={variant === "major" ? "lg" : "md"}
        // @ts-expect-error
        title={formatted_date}
      >
        {formatted_time}
        {!!day_difference && day_difference > 0 && (
          <Label component="sup" fontWeight="bold" size="sm">
            +{day_difference}
          </Label>
        )}
      </Label>
    </div>
  );
};
